"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSalesposterResponse = isValidSalesposterResponse;
/**
 * Validates that the response is a valid salesposter response containing a proper response
 * If this function returns false, error handling should be invoked and a fallback poster should be served
 * @param response the response from salesposter endpoint in json format
 * @returns if the response is a valid salesposter response containing a poster
 */
function isValidSalesposterResponse(response) {
    return (
    // Validate response is an object and not null
    !!response &&
        typeof response === 'object' &&
        // Validate status is present and is 200
        'status' in response &&
        typeof response.status === 'number' &&
        response.status === 200 &&
        // Validate reponse.data is present and is an object and not null
        'data' in response &&
        !!response.data &&
        typeof response.data === 'object' &&
        // Validate reponse.data contains content that is a string
        'content' in response.data &&
        typeof response.data.content === 'string');
}
//# sourceMappingURL=is-valid-salesposter-response.js.map